import FormSwitch from 'src/components/form-switch';

import { IEdgeExtraData } from '../types';

export function CustomEdgeEditMonitoring({
  data,
  onChangeEdgeData,
}: {
  data: IEdgeExtraData;
  onChangeEdgeData: (data: Partial<IEdgeExtraData>) => void;
}) {
  const { enableMonitoring = false } = data || {};

  return (
    <div
      className="mt-2 flex flex-col items-start justify-center gap-4"
      data-testid="dialog-custom-edge-edit-monitoring-panel"
    >
      <div className="flex flex-row items-center justify-center gap-4">
        <FormSwitch
          data-testid="dialog-custom-edge-edit-monitoring-switch"
          checked={enableMonitoring}
          label="ITxPT status reporting expects the link to be up."
          wrapperClassName="flex-row-reverse"
          onChange={() =>
            onChangeEdgeData({ enableMonitoring: !enableMonitoring })
          }
        />
      </div>
    </div>
  );
}
